var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:url(#SVGID_1_);}\n\t.st2{display:inline;fill:url(#SVGID_2_);}\n\t.st3{display:inline;fill:url(#SVGID_3_);}\n\t.st4{display:inline;fill:url(#SVGID_4_);}\n\t.st5{display:inline;fill:url(#SVGID_5_);}\n\t.st6{display:inline;fill:url(#SVGID_6_);}\n\t.st7{display:inline;fill:url(#SVGID_7_);}\n\t.st8{display:inline;fill:url(#SVGID_8_);}\n\t.st9{display:inline;fill:url(#SVGID_9_);}\n\t.st10{display:inline;fill:url(#SVGID_10_);}\n\t.st11{fill:url(#SVGID_11_);}\n\t.st12{fill:url(#SVGID_12_);}\n\t.st13{fill:url(#SVGID_13_);}\n\t.st14{fill:url(#SVGID_14_);}\n\t.st15{fill:url(#SVGID_15_);}\n\t.st16{fill:url(#SVGID_16_);}\n\t.st17{fill:url(#SVGID_17_);}\n\t.st18{fill:url(#SVGID_18_);}\n\t.st19{fill:url(#SVGID_19_);}\n\t.st20{fill:url(#SVGID_20_);}\n\t.st21{fill:url(#SVGID_21_);}\n\t.st22{fill:url(#SVGID_22_);}\n\t.st23{display:inline;fill:url(#SVGID_23_);}\n\t.st24{display:inline;fill:url(#SVGID_24_);}\n\t.st25{display:inline;fill:url(#SVGID_25_);}\n\t.st26{display:inline;fill:url(#SVGID_26_);}\n\t.st27{display:inline;fill:url(#SVGID_27_);}\n\t.st28{display:inline;fill:url(#SVGID_28_);}\n\t.st29{display:inline;fill:url(#SVGID_29_);}\n\t.st30{display:inline;fill:url(#SVGID_30_);}\n\t.st31{display:inline;fill:url(#SVGID_31_);}\n\t.st32{display:inline;fill:url(#SVGID_32_);}\n\t.st33{display:inline;fill:url(#SVGID_33_);}\n\t.st34{display:inline;fill:url(#SVGID_34_);}\n\t.st35{display:inline;fill:url(#SVGID_35_);}\n\t.st36{display:inline;fill:url(#SVGID_36_);}\n\t.st37{display:inline;fill:url(#SVGID_37_);}\n\t.st38{display:inline;fill:url(#SVGID_38_);}\n\t.st39{display:inline;fill:url(#SVGID_39_);}\n\t.st40{display:inline;fill:url(#SVGID_40_);}\n\t.st41{display:inline;fill:url(#SVGID_41_);}\n\t.st42{display:inline;fill:url(#SVGID_42_);}\n\t.st43{display:inline;fill:url(#SVGID_43_);}\n\t.st44{display:inline;fill:url(#SVGID_44_);}\n\t.st45{display:inline;fill:url(#SVGID_45_);}\n\t.st46{display:inline;fill:url(#SVGID_46_);}\n\t.st47{display:inline;fill:url(#SVGID_47_);}\n\t.st48{display:inline;fill:url(#SVGID_48_);}\n\t.st49{display:inline;fill:url(#SVGID_49_);}\n\t.st50{display:inline;fill:url(#SVGID_50_);}\n\t.st51{display:inline;fill:url(#SVGID_51_);}\n\t.st52{display:inline;fill:url(#SVGID_52_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.7647,
    y1: 133.9515,
    x2: 257.0479,
    y2: 138.159,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D6828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#9E6A29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    style: {
      stopColor: "#A26E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#A87639"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#B2814A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#BF9162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#D1A880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6AE87"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "252.8,18.6 250.8,257.2 173.6,173  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.5992,
    y1: 424.7624,
    x2: 160.8026,
    y2: 364.5179,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D6828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#9E6A29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    style: {
      stopColor: "#A26E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#A87639"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#B2814A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#BF9162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#D1A880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6AE87"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "91.8,488.9 246.7,410.6 250.8,257.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.1104,
    y1: 495.8223,
    x2: 320.1104,
    y2: 257.2556,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB78"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "399,493.7 250.8,257.2 246.7,410.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.5274,
    y1: 340.1212,
    x2: 321.7392,
    y2: 377.4809,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D6828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#9E6A29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    style: {
      stopColor: "#A26E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#A87639"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#B2814A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#BF9162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#D1A880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6AE87"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "372.4,322.3 399,493.7 250.8,257.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.3297,
    y1: 308.3915,
    x2: 488.6128,
    y2: 188.1392,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB78"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "498.5,203.1 372.4,322.3 250.8,257.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.748,
    y1: 169.4249,
    x2: 375.2463,
    y2: 232.9295,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D6828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#9E6A29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    style: {
      stopColor: "#A26E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#A87639"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#B2814A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#BF9162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#D1A880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6AE87"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "327.2,175.4 498.5,203.1 250.8,257.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.47,
    y1: 139.1109,
    x2: 324.4052,
    y2: 131.7675,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB78"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "252.8,18.6 327.2,175.4 250.8,257.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.7334,
    y1: 235.0255,
    x2: 137.0249,
    y2: 165.3168,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB78"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1.5,195.3 250.8,257.2 173.6,173  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.3772,
    y1: 382.5573,
    x2: 110.118,
    y2: 344.1993,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4BB78"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "91.8,488.9 250.8,257.2 123.8,318.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5358,
    y1: 309.7339,
    x2: 128.0538,
    y2: 219.7264,
    gradientTransform: "matrix(0.9999 -1.404884e-02 1.404884e-02 0.9999 -3.5801 3.5298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9D6828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2136,
    style: {
      stopColor: "#9E6A29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    style: {
      stopColor: "#A26E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    style: {
      stopColor: "#A87639"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#B2814A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#BF9162"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    style: {
      stopColor: "#D1A880"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6AE87"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1.5,195.3 123.8,318.4 250.8,257.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.9605,
    y1: 83.048,
    x2: 280.2489,
    y2: 52.282,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06948203,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1678,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3951,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5317,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808285"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "259.4,7.3 252.8,253.3 317.2,148.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.6797,
    y1: 165.5668,
    x2: 131.505,
    y2: 16.8996,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "194.1,145.1 252.8,253.3 259.4,7.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.3951,
    y1: 96.7843,
    x2: 305.7977,
    y2: 45.9372,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "317.2,148.4 469.2,135.9 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.3131,
    y1: 113.8141,
    x2: 350.0247,
    y2: 83.048,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2992,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4683,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "375.8,256.6 469.2,135.9 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.774,
    y1: 250.2221,
    x2: 339.3398,
    y2: 129.0275,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "462.6,382 252.8,253.3 375.8,256.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.5569,
    y1: 251.157,
    x2: 411.5569,
    y2: 189.6248,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2992,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4683,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "311.5,361.5 252.8,253.3 462.6,382  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.7977,
    y1: 333.3125,
    x2: 366.3951,
    y2: 282.4653,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2992,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4683,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7242,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "188.5,358.2 246.3,499.3 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.4803,
    y1: 362.3501,
    x2: 268.3056,
    y2: 213.6828,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "311.5,361.5 246.3,499.3 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.1875,
    y1: 333.3125,
    x2: 210.5902,
    y2: 282.4653,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "36.5,370.7 188.5,358.2 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.0416,
    y1: 303.5105,
    x2: 172.708,
    y2: 276.4553,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06948203,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1678,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3951,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5317,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808285"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "129.8,250 252.8,253.3 36.5,370.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.6454,
    y1: 250.2221,
    x2: 93.2113,
    y2: 129.0275,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#E5E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3246,
    style: {
      stopColor: "#DADBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5683,
    style: {
      stopColor: "#D3D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D1D3D4"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "43,124.6 129.8,250 252.8,253.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.4284,
    y1: 189.6248,
    x2: 165.4284,
    y2: 128.0927,
    gradientTransform: "matrix(0.8524 0.5228 -0.5228 0.8524 106.0467 -59.1775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06948203,
    style: {
      stopColor: "#D0D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1678,
    style: {
      stopColor: "#B6B8BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2758,
    style: {
      stopColor: "#A2A4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3951,
    style: {
      stopColor: "#929597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5317,
    style: {
      stopColor: "#888A8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#828487"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808285"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "194.1,145.1 252.8,253.3 43,124.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.8297,
    y1: 133.8101,
    x2: 195.0444,
    y2: 155.3671,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "252,244.9 361.5,484.7 350.7,336.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9876,
    y1: 222.0439,
    x2: 190.1664,
    y2: 161.6638,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685569,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A68747"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "498,313.5 252,244.9 350.7,336.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.9869,
    y1: 215.6678,
    x2: 159.6652,
    y2: 265.9008,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "375,229.3 252,244.9 498,313.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.0425,
    y1: 327.9812,
    x2: 163.2486,
    y2: 278.7151,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685569,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A68747"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "449.3,100.1 252,244.9 375,229.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.3298,
    y1: 327.0003,
    x2: 227.5246,
    y2: 367.1834,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "306.8,143.8 252,244.9 449.3,100.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.309,
    y1: 374.985,
    x2: 242.5775,
    y2: 374.985,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685569,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A68747"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "252,5.1 306.8,143.8 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.1272,
    y1: 374.839,
    x2: 351.3203,
    y2: 376.8712,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "197.3,143.8 252,5.1 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.2141,
    y1: 366.9275,
    x2: 396.852,
    y2: 326.2696,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A68747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4143,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5926,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9314,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F2A8"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "54.8,100.1 197.3,143.8 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.0116,
    y1: 328.712,
    x2: 432.0659,
    y2: 279.5392,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "129.1,229.3 252,244.9 54.8,100.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.7628,
    y1: 267.323,
    x2: 419.9488,
    y2: 219.5005,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A68747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4143,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5926,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9314,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F2A8"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "6.1,313.5 129.1,229.3 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.5409,
    y1: 221.6487,
    x2: 403.3825,
    y2: 161.8102,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "153.4,336.1 6.1,313.5 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.167,
    y1: 135.6921,
    x2: 299.4009,
    y2: 111.7539,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF9AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04788452,
    style: {
      stopColor: "#F8E9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#E8D499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    style: {
      stopColor: "#DDC792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5277,
    style: {
      stopColor: "#D7BF8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D5BD8C"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "142.6,484.7 252,383.5 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.1067,
    y1: 157.1379,
    x2: 351.0733,
    y2: 134.7396,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A68747"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4143,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5926,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7255,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9314,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F5F2A8"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "153.4,336.1 142.6,484.7 252,244.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.6103,
    y1: 135.6416,
    x2: 294.7107,
    y2: 110.8804,
    gradientTransform: "matrix(-1 0 0 -1 549.3478 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F2A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685569,
    style: {
      stopColor: "#DCCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#C7B36F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    style: {
      stopColor: "#B89E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    style: {
      stopColor: "#AE9150"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    style: {
      stopColor: "#A88949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A68747"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "252,383.5 361.5,484.7 252,244.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9518,
    y1: 133.0865,
    x2: 246.9727,
    y2: 114.2691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "250,250 152.2,13.8 250,122.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.5452,
    y1: 148.459,
    x2: 206.3163,
    y2: 129.9799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "159.6,159.6 250,250 152.2,13.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.6879,
    y1: 204.2004,
    x2: 149.3226,
    y2: 155.6551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "13.8,152.2 159.6,159.6 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.2691,
    y1: 246.9727,
    x2: 133.0865,
    y2: 197.9518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "122.2,250 13.8,152.2 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.2603,
    y1: 262.2752,
    x2: 149.4294,
    y2: 323.0688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "13.8,347.8 250,250 122.2,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.3226,
    y1: 344.3449,
    x2: 130.6879,
    y2: 295.7997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "159.6,340.4 250,250 13.8,347.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.8129,
    y1: 314.0717,
    x2: 240.3392,
    y2: 422.154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "152.2,486.2 250,250 159.6,340.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.9727,
    y1: 385.7309,
    x2: 197.9518,
    y2: 366.9135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "250,377.8 250,250 152.2,486.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.6032,
    y1: 272.0846,
    x2: 365.7408,
    y2: 473.2257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "347.8,486.2 250,377.8 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.6066,
    y1: 347.277,
    x2: 293.8699,
    y2: 370.4695
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "340.4,340.4 250,250 347.8,486.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.0411,
    y1: 210.7368,
    x2: 432.1845,
    y2: 387.1111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "486.2,347.8 340.4,340.4 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.195,
    y1: 253.9691,
    x2: 367.6769,
    y2: 299.9509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "377.8,250 486.2,347.8 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.5706,
    y1: 176.9312,
    x2: 394.7397,
    y2: 237.7248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "486.2,152.2 377.8,250 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.9643,
    y1: 155.9649,
    x2: 368.5487,
    y2: 202.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "340.4,159.6 486.2,152.2 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.6608,
    y1: 77.846,
    x2: 338.1871,
    y2: 185.9283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CAE8E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    style: {
      stopColor: "#CDD8D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4335,
    style: {
      stopColor: "#D0CED1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6929,
    style: {
      stopColor: "#D1C7CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2C6CD"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "347.8,13.8 340.4,159.6 250,250  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.5674,
    y1: 110.7408,
    x2: 305.9388,
    y2: 135.3085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2C4C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4157,
    style: {
      stopColor: "#D8D9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "250,122.2 347.8,13.8 250,250  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.fb748b71f78a882c7d83582771dabfbc.svg";
export { ForwardRef as ReactComponent };